import { useEffect, useRef, useState } from 'react';
import axios from '../../service/axios';
import { AppStorage } from '../../service/UserStorage';
import { AccountService } from '../../service/AccountService';
import { ApplicationConfigurationService } from '../../service/ApplicationConfigurationService';

export default function BangGiaVang() {
  const preview = useRef(null);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    if (!AppStorage.get('tenantName')) {
      window.location.hash = '/login';
    } else {
      AccountService.getMyProfile().then((user) => {
        if (user?.userName) {
          const interval = setInterval(() => {
            setVersion(Date.now());
          }, 1000 * 20);

          return () => clearInterval(interval);
        } else {
          window.location.hash = '/login';
        }
      }).catch(() => {
        window.location.hash = '/login';
      });
    }

  }, []);

  useEffect(() => {
    axios.get(`/api/app/tenant-price/price-html?version=${version}`).then(({ data }) => {
      const htmlWithExternalScript = `${data.html?.trim()}`;
      preview.current.contentWindow.document.open();
      preview.current.contentWindow.document.write(htmlWithExternalScript);
    });
  }, [version]);

  return (
    <div className="board-container">
      <iframe className="board" ref={preview} title="template-preview" />
    </div>
  );
}